import { CommonModule, Location } from '@angular/common';
import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '@app/components/confirm-dialog';
import { SaveChangesService } from '@app/services/save-changes/save-changes.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-save-changes-confirmation',
  standalone: true,
  imports: [CommonModule, ConfirmDialogComponent, TranslatePipe],
  templateUrl: './save-changes-confirmation.component.html',
})
export class SaveChangesConfirmationComponent implements OnInit {
  private readonly saveChanges = inject(SaveChangesService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly location = inject(Location);
  private readonly router = inject(Router);
  @Input() navigate!: string[];
  @Input() navigateUrl!: string;
  dialogOpen = signal(false);
  saveGuardUrl = '';

  ngOnInit(): void {
    this.saveChanges.notification$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((url) => {
        this.saveGuardUrl = url;
        this.dialogOpen.set(!!url);
      });
  }

  dialogClosed(): void {
    this.dialogOpen.set(false);
  }

  exit() {
    this.dialogOpen.set(false);
    this.saveChanges.setHasChanges(false);
    if (this.saveGuardUrl) {
      this.router.navigateByUrl(this.saveGuardUrl);
    } else if (this.navigate?.length) {
      this.router.navigate(this.navigate);
    } else if (this.navigateUrl) {
      this.router.navigateByUrl(this.navigateUrl);
    } else {
      this.location.back();
    }
  }

  cancel() {
    this.dialogOpen.set(false);
    this.saveGuardUrl = '';
  }
}
